/* eslint-disable global-require */
import axios from "axios";
import React, { useEffect, useState, useContext } from "react";
import { Col, Row, Image, Container, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { getCookies } from "../../hooks/useCookies";
import { TableContext } from "../../contexts/tableContext";
import { confirmAlert } from "react-confirm-alert";
import { toast } from "react-toastify";
import styles from "./viewPopup.module.scss";
import envValues from "../../enviornment";
import { Entry } from "../../redux/entrySlice";
import { useDispatch } from "react-redux";
import Loader from "../../components/Loader/Loader";

const ViewSuggestionPopup = React.memo(
  ({ suggestionId, handleClose, setIsUpdated }) => {
    const { formthemeStyle, viewformStyle } = useContext(TableContext);
    const dispatch = useDispatch();
    const token = `Bearer ${getCookies("Token")}`;
    const [loading, setLoading] = useState(false);
    const [details, setDetails] = useState([]);

    const getUserDetails = async () => {
      setLoading(true);
      axios
        .get(
          `${envValues.REACT_APP_API_ENDPOINT}/cafe/suggested-cafe/${suggestionId}`,
          {
            method: "GET",
            headers: { Authorization: token },
          }
        )
        .then((resp) => {
          const statusCode = resp.status;
          return { statusCode, data: resp.data };
        })
        .then(({ statusCode, data: res }) => {
          if (statusCode === 200) {
            setDetails(res.data.cafe);
          }
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
    };

    useEffect(() => {
      window.scrollTo(0, 0);
      getUserDetails();
    }, [suggestionId]);

    const handleDelete = () => {
      const cafeName = details?.cafeName || "this suggestion";
      confirmAlert({
        title: "",
        message: `Are you sure you want to delete the suggested cafe "${cafeName}"?`,
        buttons: [
          {
            label: "Yes",
            onClick: () => {
              const actionData = {
                actionUrl: `cafe/suggested-cafe/${suggestionId}`,
                actionMethod: "delete",
              };
              dispatch(Entry(actionData)).then((resp) => {
                if (resp.payload?.code === 200 || resp.payload?.success) {
                  toast.success("Suggested cafe deleted successfully");
                  setIsUpdated?.(true);
                  handleClose();
                } else {
                  toast.error(
                    resp.payload?.message || "Failed to delete suggested cafe"
                  );
                }
              });
            },
          },
          {
            label: "No",
          },
        ],
      });
    };

    return (
      <div className={styles.popupbox}>
        <div className={styles[formthemeStyle]} id={styles.box}>
          <span
            className={styles.closeicon}
            role="button"
            tabIndex={0}
            onClick={handleClose}
            onKeyPress={handleClose}
          >
            <FontAwesomeIcon icon={faTimes} />
          </span>
          {loading ? (
            <Loader centered />
          ) : (
            <Container fluid>
              <Row>
                <Col lg={8}>
                  <h5 id="addheading">Suggested Cafe Details</h5>
                </Col>
                <Col lg={4} className="text-end">
                  <Button
                    variant="danger"
                    size="sm"
                    onClick={handleDelete}
                    aria-label="Delete suggested cafe"
                  >
                    <i className="fa fa-trash" /> Delete
                  </Button>
                </Col>
              </Row>
              <Row>
                <Col lg={12}>
                  <div className={styles.profilepicdiv}>
                    {details.image ? (
                      <Image
                        src={details.image}
                        alt="logo"
                        className={styles.profilepic}
                      />
                    ) : (
                      <div>{details.name}</div>
                    )}
                  </div>
                </Col>
              </Row>
              <Row className="mt-3">
                <Col lg={12} md={12} sm={12}>
                  <div className={styles.detaildiv}>
                    <Row>
                      <Col lg={6}>
                        <div
                          className={styles[viewformStyle]}
                          id={styles.empdiv}
                        >
                          <span className={styles.title}>Name</span>
                          <p className={styles.empname}>
                            {details?.user?.name}
                          </p>
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div
                          className={styles[viewformStyle]}
                          id={styles.empdiv}
                        >
                          <span className={styles.title}>Email</span>
                          <p className={styles.empname}>
                            {details?.user?.email ?? "NA"}
                          </p>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={6}>
                        <div
                          className={styles[viewformStyle]}
                          id={styles.empdiv}
                        >
                          <span className={styles.title}>Cafe Name</span>
                          <p className={styles.empname}>
                            {details?.cafeName ?? "NA"}
                          </p>
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div
                          className={styles[viewformStyle]}
                          id={styles.empdiv}
                        >
                          <span className={styles.title}>Owner Name</span>
                          <p className={styles.empname}>
                            {details?.ownerName ?? "NA"}
                          </p>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={6}>
                        <div
                          className={styles[viewformStyle]}
                          id={styles.empdiv}
                        >
                          <span className={styles.title}>Address</span>
                          <p className={styles.empname}>
                            {details?.address ?? "NA"}
                          </p>
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div
                          className={styles[viewformStyle]}
                          id={styles.empdiv}
                        >
                          <span className={styles.title}>City/State</span>
                          <p className={styles.empname}>
                            {details?.city ?? details?.cityState ?? "NA"}
                          </p>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={6}>
                        <div
                          className={styles[viewformStyle]}
                          id={styles.empdiv}
                        >
                          <span className={styles.title}>Favorite Drink</span>
                          <p className={styles.empname}>
                            {details?.favDrink ?? "NA"}
                          </p>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={6}>
                        <div
                          className={styles[viewformStyle]}
                          id={styles.empdiv}
                        >
                          <span className={styles.title}>
                            Reason for suggestion
                          </span>
                          <p className={styles.empname}>
                            {details?.description ?? details?.reason ?? "NA"}
                          </p>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
            </Container>
          )}
        </div>
      </div>
    );
  }
);

export default ViewSuggestionPopup;
